import React, { useState } from 'react';
import {SearchBar, Icons} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import ConfirmationModal from  './confirmationModal';
import { Button } from '@xpertdox_js/xdcomponents';
import { trackError } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext';
import dataTableSettings from '../TrialUI/dataTableSettings';
import userManagementSetting from './userManagementSetting';


// removed xperttrial from allApps
const allApps = ["xt_console", "xt_screen", "xt_dashboard"];

const EditApps = (props) => {
  const { data, adminUser } = props
  const { userAction } = React.useContext(UserContext);
  const [apps, setApps] = React.useState(data.appAccess)

  const addRemoveApp = (appName, isSelected) => {
    // console.log('addRemoveApp called',appName, isSelected, data._id, data.appAccess)
    let newApps = apps;
    const appIndex = newApps.indexOf(appName);
    if (isSelected) { // to remove app
      if (appIndex !== -1) newApps.splice(appIndex, 1);
    } else { // to add app
      if (appIndex === -1) newApps.push(appName);
    }

    const dataObj = {
      email: data.email,
      userId: data._id,
      appAccess: newApps
    }
    // removed 'axiosConfig.auth' as token is updated on login
    axios.put(`${axiosConfig.apiUrl}/rt/console/updateAppAccess/${adminUser.email}`, dataObj)
    .then(response => {
      // console.log('success', response);
      // props.userDetails();
      setApps(newApps)
      // props.dataRefresh();
    }).catch(error => {
      console.log('error', error);
      trackError({ error: error, history: props.history })
      if (error.response.status === 403) {
        userAction({type: 'logout'})
      }
    });
  }
  return (
        <React.Fragment>
          <p style={styles.heading}>App Access</p>
          <div style={styles.nct}>
            {allApps.map((value, index) => {
              let isSelected = false;
              if(apps && apps.length > 0 && apps.indexOf(value) > -1) isSelected = true;
              return (
                <Button
                  key={index}
                  id={`nct_${index}`}
                  styles={styles.nctContainer}
                  hoverStyles={styles.nctHover}
                  onClick={() => addRemoveApp(value, isSelected)}
                >
                  {userManagementSetting.app[value]}
                  <Icons icon={isSelected ? 'check': 'circle'} style={styles.icon}  />
                </Button>
              )
            })}
          </div>
        </React.Fragment>
  )
}

export default EditApps;
